import { Route, UrlSegment } from '@angular/router';
import { LOCATION_ROUTES } from '../static/courses-filter.properties';

export const validateLocationGuard = (_route: Route, segments: UrlSegment[]) => {
	const location = segments.at(-1)?.path as any;
	return LOCATION_ROUTES.includes(location);
};
